if (!customElements.get('global-faq')) {
  class GlobalFaq extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.tabs = Array.from(this.querySelectorAll('.global-faq__tab'));
      this.items = Array.from(this.querySelectorAll('[data-faq-item]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab), { signal: this.controller.signal });
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    activate(tab) {
      const filter = tab.dataset.filter;

      this.tabs.forEach((t) => {
        const isActive = t === tab;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.items.forEach((item) => {
        const show = filter === 'all' || item.dataset.category === filter;
        item.hidden = !show;
      });
    }
  }

  customElements.define('global-faq', GlobalFaq);
}
